export interface CheckClientEvrotrustInterface {
  isRegistered: string; //
  isIdentified: string; //
  isRejected: string; //
  isSupervised: string; //
  isReadyToSign: string; //
  hasConfirmedPhone: string; //
  hasConfirmedEmail: string; //
  errorDTO: ErrorDTO; //
}

export interface ErrorDTO {
  errorCode: string;
}

export enum CheckClientEvrotrustEnum {
  isRegistered = "1",
  isIdentified = "1",
  isRejected = "0",
  isSupervised = "1",
  isReadyToSign = "1",
  hasConfirmedPhone = "1",
  hasConfirmedEmail = "1",
}
